/*
 * A/B Test Revenue Calculator (sections/ab-test-calculator.liquid).
 * revenue anual = sesiones al mes × 12 × conversión × ticket promedio.
 * Filas: revenue × 3% / 5% / 10%. "Keep testing": revenue × (1.05^n − 1), n = 2, 4 o 6 wins.
 * Mientras falte un dato válido se usa el de ejemplo y todo se pinta en gris.
 * Lectura de números y errores: igual que la ROI calculator (roi-calculator.js).
 */
(function () {
  var SYMBOLS = { USD: '$', MXN: 'MX$', EUR: '€', GBP: '£' };
  // Ejemplo = los números de los placeholders, con un AOV realista por moneda
  var EXAMPLE_AOV = { USD: 75, MXN: 1400, EUR: 70, GBP: 60 };
  var EXAMPLE = { s: 100000, cr: 2 };
  var WINS = [2, 4, 6];
  var LIFT = 0.05;
  var ANIMATION_MS = 450;
  var FIELDS = ['s', 'cr', 'aov'];
  var KINDS = { s: 'sessions', cr: 'rate', aov: 'amount' };
  var MESSAGES = {
    number: 'Numbers only here',
    sessions: 'Enter sessions above 0',
    rate: 'Use a rate between 0.1% and 100%, like 2.5',
    amount: 'Add your average order value, like ',
  };
  var EGGS = {
    cr25: "25%? Okay, now you're just showing off.",
    cr10: "10%+? Honestly, you might not need us. But we'd love to hear how you did it.",
    sessions: '5M+ visits a month? We should definitely talk.',
  };

  function ok(v) {
    return typeof v === 'number' && Number.isFinite(v) && v > 0;
  }

  function rate(v) {
    return typeof v === 'number' && Number.isFinite(v) && v >= 0.1 && v <= 100;
  }

  function valid(key, v) {
    return key === 'cr' ? rate(v) : ok(v);
  }

  /*
   * Lectura de números por tipo de campo: 'sessions', 'rate' (conversión) o
   * 'amount' (AOV). Devuelve { value, error }. Un campo vacío no es error.
   */
  function parseField(kind, raw) {
    var text = String(raw === null || raw === undefined ? '' : raw).trim();
    if (text === '') return { value: NaN, error: null };

    var clean = text.replace(/MX\$/gi, '').replace(/[$£€%\s]/g, '');
    var value;

    if (kind === 'sessions') {
      var digits = clean.replace(/[^0-9]/g, '');
      if (digits === '') return { value: NaN, error: MESSAGES.number };
      value = parseInt(digits, 10);
    } else {
      if (kind === 'rate') {
        // En conversión la coma siempre es decimal: "2,5" = 2.5.
        clean = clean.replace(/,/g, '.');
      } else {
        // En AOV, coma + 3 dígitos = miles ("1,250"); coma + 1 o 2 = decimal ("82,5").
        clean = clean.replace(/,(\d{3})(?=$|[.,])/g, '$1').replace(/,(?=\d{1,2}$)/, '.');
      }
      if (!/^-?(\d+\.?\d*|\.\d+)$/.test(clean)) return { value: NaN, error: MESSAGES.number };
      value = parseFloat(clean);
    }

    if (kind === 'sessions' && !ok(value)) return { value: NaN, error: MESSAGES.sessions };
    if (kind === 'rate' && !rate(value)) return { value: NaN, error: MESSAGES.rate };
    if (kind === 'amount' && !ok(value)) return { value: NaN, error: 'amount' };
    return { value: value, error: null };
  }

  // Para mostrar en un input: hasta 2 decimales, sin ceros de sobra.
  function toFieldValue(key, n) {
    if (!Number.isFinite(n)) return '';
    var rounded = Math.round(n * 100) / 100;
    if (key === 's' || key === 'aov') return rounded.toLocaleString('en-US', { maximumFractionDigits: 2 });
    return String(rounded);
  }

  function init(root) {
    var fields = {};
    root.querySelectorAll('[data-ab-field]').forEach(function (el) {
      fields[el.getAttribute('data-ab-field')] = el;
    });
    var errorEls = {};
    root.querySelectorAll('[data-ab-error]').forEach(function (el) {
      errorEls[el.getAttribute('data-ab-error')] = el;
    });
    var hintEls = {};
    root.querySelectorAll('[data-ab-hint]').forEach(function (el) {
      hintEls[el.getAttribute('data-ab-hint')] = el;
    });
    var outputs = {};
    root.querySelectorAll('[data-ab-out]').forEach(function (el) {
      outputs[el.getAttribute('data-ab-out')] = el;
    });
    var form = root.querySelector('[data-ab-form]');
    var symbol = root.querySelector('[data-ab-symbol]');
    var annualLabel = root.querySelector('[data-ab-annual-label]');
    var exTag = root.querySelector('[data-ab-extag]');
    var note = root.querySelector('[data-ab-note]');
    var lifts = root.querySelectorAll('[data-ab-lift]');
    var stack = root.querySelector('[data-ab-stack]');
    var chips = root.querySelectorAll('[data-ab-wins]');
    var nEl = root.querySelector('[data-ab-n]');
    var big = root.querySelector('[data-ab-big]');
    var placeholder = root.querySelector('[data-ab-placeholder]');
    var stepsWrap = root.querySelector('[data-ab-steps]');
    var steps = root.querySelectorAll('[data-ab-step]');
    var sumLabel = root.querySelector('[data-ab-sum-label]');
    var copyBtn = root.querySelector('[data-ab-copy]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var state = { s: NaN, cr: NaN, aov: NaN, wins: 4 };
    var errors = {}; // error vigente por campo (se muestre o no)
    var shownErrors = {}; // errores ya pintados (solo tras blur)
    var shown = {}; // último valor pintado por output, para animar desde ahí
    var tokens = {}; // animación en curso por output

    // Alto de cada barra: lo extra acumulado tras k wins, sobre el máximo (6 wins).
    var maxGain = Math.pow(1 + LIFT, 6) - 1;
    steps.forEach(function (el) {
      var k = +el.getAttribute('data-ab-step');
      el.style.setProperty('--h', ((Math.pow(1 + LIFT, k) - 1) / maxGain * 100).toFixed(1) + '%');
    });

    function currency() {
      return SYMBOLS[fields.cur.value] ? fields.cur.value : 'USD';
    }

    function money(v) {
      return SYMBOLS[currency()] + Math.round(v).toLocaleString('en-US');
    }

    function plus(v) {
      return '+' + money(v);
    }

    function exampleAov() {
      return SYMBOLS[currency()] + EXAMPLE_AOV[currency()].toLocaleString('en-US');
    }

    function errorText(key) {
      var e = errors[key];
      return e === 'amount' ? MESSAGES.amount + EXAMPLE_AOV[currency()].toLocaleString('en-US') : e;
    }

    function readField(key) {
      var parsed = parseField(KINDS[key], fields[key].value);
      state[key] = parsed.value;
      errors[key] = parsed.error;
      // Una vez visible, el error se actualiza mientras se escribe y se quita al corregir.
      if (shownErrors[key]) {
        if (parsed.error) showError(key);
        else hideError(key);
      }
    }

    function showError(key) {
      var input = fields[key];
      var el = errorEls[key];
      shownErrors[key] = true;
      input.setAttribute('aria-invalid', 'true');
      el.textContent = errorText(key);
      el.hidden = false;
      input.setAttribute('aria-describedby', el.id);
      setHint(key, null);
    }

    function hideError(key) {
      var input = fields[key];
      shownErrors[key] = false;
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      errorEls[key].textContent = '';
      errorEls[key].hidden = true;
    }

    // Comentarios bajo el campo: salen al salir del campo, nunca mientras se escribe.
    function setHint(key, text) {
      var el = hintEls[key];
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
      if (text && !shownErrors[key]) fields[key].setAttribute('aria-describedby', el.id);
      else if (!text && fields[key].getAttribute('aria-describedby') === el.id) fields[key].removeAttribute('aria-describedby');
    }

    function eggFor(key) {
      if (key === 'cr' && rate(state.cr)) {
        if (state.cr >= 25) return EGGS.cr25;
        if (state.cr >= 10) return EGGS.cr10;
      }
      if (key === 's' && ok(state.s) && state.s >= 5000000) return EGGS.sessions;
      return null;
    }

    // Conteo de cifras: del valor anterior al nuevo; un cambio a media animación cancela la anterior.
    function paint(key, value, formatter) {
      var el = outputs[key];
      if (!el) return;
      var from = shown[key];
      var token = {};
      tokens[key] = token;
      function put(v) {
        shown[key] = v;
        el.textContent = formatter(v);
      }
      if (reduceMotion || from === undefined || from === value || document.hidden) {
        put(value);
        return;
      }
      var start = null;
      function step(ts) {
        if (tokens[key] !== token) return;
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / ANIMATION_MS);
        var eased = 1 - Math.pow(1 - t, 3);
        put(t === 1 ? value : from + (value - from) * eased);
        if (t < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    function paintEl(el, key, value, formatter) {
      outputs[key] = el;
      paint(key, value, formatter);
    }

    function render() {
      var cur = currency();
      symbol.textContent = SYMBOLS[cur];
      symbol.parentNode.style.setProperty('--affix-w', symbol.offsetWidth + 'px');
      fields.aov.placeholder = 'e.g. ' + EXAMPLE_AOV[cur].toLocaleString('en-US');
      // El mensaje de error del AOV nombra el ejemplo de la moneda.
      if (shownErrors.aov) errorEls.aov.textContent = errorText('aov');

      // Un campo vacío o con error usa el valor de ejemplo hasta que se corrige.
      var use = {};
      var missing = [];
      var example = { s: EXAMPLE.s, cr: EXAMPLE.cr, aov: EXAMPLE_AOV[cur] };
      FIELDS.forEach(function (key) {
        if (valid(key, state[key])) {
          use[key] = state[key];
        } else {
          use[key] = example[key];
          missing.push(key);
        }
      });
      var isExample = missing.length > 0;
      var annual = use.s * 12 * (use.cr / 100) * use.aov;
      var compounded = annual * (Math.pow(1 + LIFT, state.wins) - 1);

      var names = {
        s: 'sessions (100,000)',
        cr: 'conversion rate (2%)',
        aov: 'AOV (' + exampleAov() + ')',
      };
      var text = '';
      if (missing.length === 3) {
        text = 'Example for a store with 100,000 sessions, 2% conversion and ' + exampleAov() + ' AOV. Add your numbers to replace it.';
      } else if (isExample) {
        text = 'Using example ' + missing.map(function (key) { return names[key]; }).join(' and ') + ' until you add yours.';
      }
      if (note.textContent !== text) note.textContent = text;
      note.hidden = !isExample;
      exTag.hidden = !isExample;
      if (copyBtn) copyBtn.hidden = isExample;
      annualLabel.textContent = isExample ? 'Example annual revenue' : 'Current annual revenue';

      paint('annual', annual, money);
      lifts.forEach(function (el, i) {
        paintEl(el, 'lift' + i, annual * parseFloat(el.getAttribute('data-ab-lift')), plus);
      });

      stack.classList.toggle('stack--ex', isExample);
      nEl.textContent = state.wins;
      big.classList.toggle('long', plus(compounded).length > 11);
      paint('comp', compounded, plus);
      paint('sum', compounded, function (v) { return plus(v) + '/year'; });
      sumLabel.textContent = isExample ? 'Add your numbers to see yours' : state.wins + ' wins a year';

      steps.forEach(function (el) {
        var k = +el.getAttribute('data-ab-step');
        el.classList.toggle('on', !isExample && k <= state.wins);
        el.classList.toggle('last', !isExample && k === state.wins);
      });

      // Sin tus 3 datos, la cifra del año no se muestra (se leería como promesa).
      big.hidden = isExample;
      placeholder.hidden = !isExample;
      outputs.sum.hidden = isExample;

      [outputs.annual, outputs.sum, big, stepsWrap].concat(Array.prototype.slice.call(lifts)).forEach(function (el) {
        el.classList.toggle('is-ex', isExample);
      });
    }

    function setWins(n) {
      state.wins = n;
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', String(+chip.getAttribute('data-ab-wins') === n));
      });
    }

    // Separador de miles mientras se escribe, sin mover el cursor de lugar.
    function formatSessionsLive(input) {
      var raw = input.value;
      if (!/^[\d,]*$/.test(raw)) return; // con letras se deja tal cual para que salga el error
      var caret = input.selectionStart === null ? raw.length : input.selectionStart;
      var digitsBefore = raw.slice(0, caret).replace(/[^0-9]/g, '').length;
      var digits = raw.replace(/[^0-9]/g, '');
      var formatted = digits === '' ? '' : Number(digits).toLocaleString('en-US');
      input.value = formatted;
      var pos = 0;
      var seen = 0;
      while (pos < formatted.length && seen < digitsBefore) {
        if (/[0-9]/.test(formatted[pos])) seen++;
        pos++;
      }
      try {
        input.setSelectionRange(pos, pos);
      } catch (e) {}
    }

    FIELDS.forEach(function (key) {
      var input = fields[key];
      input.addEventListener('input', function () {
        if (key === 's') formatSessionsLive(input);
        setHint(key, null);
        readField(key);
        render();
      });
      // Un valor inválido se marca solo al salir del campo.
      input.addEventListener('blur', function () {
        readField(key);
        if (errors[key]) {
          showError(key);
        } else {
          if (Number.isFinite(state[key])) input.value = toFieldValue(key, state[key]);
          setHint(key, eggFor(key));
        }
        render();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
    });
    fields.cur.addEventListener('change', render);

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        setWins(+chip.getAttribute('data-ab-wins'));
        render();
      });
    });

    // "Copy link with my numbers": ?cur=USD&s=250000&cr=2.5&aov=90&wins=4
    if (copyBtn) {
      var copyLabel = copyBtn.textContent;
      var copyTimer = null;
      copyBtn.addEventListener('click', function () {
        var params = new URLSearchParams({ cur: currency(), s: state.s, cr: state.cr, aov: state.aov, wins: state.wins });
        var url = window.location.origin + window.location.pathname + '?' + params.toString();
        var done = function () {
          copyBtn.textContent = 'Link copied';
          clearTimeout(copyTimer);
          copyTimer = setTimeout(function () { copyBtn.textContent = copyLabel; }, 2000);
        };
        var fallback = function () { window.prompt('Copy this link', url); };
        try {
          navigator.clipboard.writeText(url).then(done, fallback);
        } catch (e) {
          fallback();
        }
      });
    }

    // Al abrir un link compartido se llenan los campos y se calcula.
    (function prefill() {
      var params = new URLSearchParams(window.location.search);
      var cur = (params.get('cur') || '').toUpperCase();
      if (SYMBOLS[cur]) fields.cur.value = cur;
      FIELDS.forEach(function (key) {
        if (!params.get(key)) return;
        fields[key].value = params.get(key);
        readField(key);
        if (errors[key]) showError(key);
        else fields[key].value = toFieldValue(key, state[key]);
      });
      var wins = +params.get('wins');
      if (WINS.indexOf(wins) !== -1) setWins(wins);
    })();

    render();
  }

  function boot() {
    document.querySelectorAll('[data-ab-calculator]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
